import script from "./GridLayoutConfigTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./GridLayoutConfigTemplate.vue?vue&type=script&setup=true&lang=js"

import "./GridLayoutConfigTemplate.vue?vue&type=style&index=0&id=b273e224&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b273e224"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
